var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98 6.186c1.026-2.053 3.08-4.107 5.134-5.134 2.054 1.027 4.108 3.08 5.135 5.134M11.115 14.187V1.108M1.052 16.037a5.158 5.158 0 004.534 4.546c1.762.197 3.57.365 5.414.365 1.845 0 3.653-.168 5.414-.365a5.158 5.158 0 004.534-4.546",
    stroke: "#1B5AF6",
    strokeWidth: 1.716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgUpload;